export function getInitialFontGeneratorText(searchParams: Pick<URLSearchParams, 'get'>): string {
  return searchParams.get('text') ?? ''
}

export function getFontGeneratorSearchParamsWithText(
  searchParams: URLSearchParams,
  text: string,
): URLSearchParams {
  const nextSearchParams = new URLSearchParams(searchParams)

  if (text.length === 0) {
    nextSearchParams.delete('text')
  } else {
    nextSearchParams.set('text', text)
  }

  return nextSearchParams
}
